module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row7_googleQRcode.9be2ce06.png";